module.exports = __webpack_public_path__ + "img/mision2.0edcc7b5.png";